import SettingsIcon from '@mui/icons-material/Settings';
import * as React from 'react';
import { useAppDispatch, useAppSelector } from '../../../../../app/hooks';
import {
  ValidPointsDropdownOptions,
  selectShowValidPointsDropdown,
  setShowValidPointsDropdown,
} from '../../../../scanDataApi/scanDataSlice';
import MapButtonMenuPopup from '../../settingsMenu/MapButtonMenuPopup';
import { MapButtonWithTooltip } from '../../settingsMenu/MapButtonWithTooltip';
import { RadioButtonGroup } from '../../settingsMenu/RadioButtonGroup';

const MapSettingsButton: React.FC = () => {
  const dispatch = useAppDispatch();
  const showValidPointsDropdown = useAppSelector(selectShowValidPointsDropdown);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(
      setShowValidPointsDropdown(
        event.target.value as ValidPointsDropdownOptions
      )
    );
  };

  const pointFilterOptions = [
    { value: 'showAllPoints', label: 'All Points' },
    { value: 'showValidPoints', label: 'Valid Points' },
    { value: 'showInvalidPoints', label: 'Invalid Points' },
  ];

  const pointFilterSelector = (
    <MapButtonMenuPopup title={'Point Filter'}>
      <RadioButtonGroup
        value={showValidPointsDropdown}
        options={pointFilterOptions}
        handleChange={handleChange}
        ariaLabel={'point-filter'}
      />
    </MapButtonMenuPopup>
  );

  return (
    <MapButtonWithTooltip
      icon={<SettingsIcon />}
      popupComponent={pointFilterSelector}
    />
  );
};

export default MapSettingsButton;
